export const SIDEBAR_IS_OPEN = 'SIDEBAR_IS_OPEN'
export const SIDEBAR_TITLE_SET = 'SIDEBAR_TITLE_SET'
export const SIDEBAR_EDIT_OPEN_TRADE = 'SIDEBAR_EDIT_OPEN_TRADE'
export const SIDEBAR_ASSET_NAME_SET = 'SIDEBAR_ASSET_NAME_SET'
export const SIDEBAR_TYPE_SET = 'SIDEBAR_TYPE_SET'

export const setSidebarIsOpen = (bool, sidebarType, assetName) => {
	return dispatch => {
		dispatch({
			payload: bool,
			type: SIDEBAR_IS_OPEN
		})
		dispatch(setSidebarAssetName(sidebarType, bool ? assetName : ''))
	}
}

export const setSidebarType = (str) => {
	return ({
		payload: str,
		type: SIDEBAR_TYPE_SET
	})
}
export const setEditOpenTrade = (tradeId, assetName, sidebarType) => {
	return dispatch => {
		dispatch({
			payload: tradeId,
			type: SIDEBAR_EDIT_OPEN_TRADE
		})
		dispatch(setSidebarIsOpen(true, sidebarType, assetName))
	}
}

export const setSidebarAssetName = (sidebarType, assetName) => {
	return dispatch => {
		dispatch({
			payload: assetName,
			type: SIDEBAR_ASSET_NAME_SET
		})
		dispatch(setSidebarType(sidebarType))
	}
}

